import { useListsApi } from '@api/configurations/lists.hook'

import { defineNuxtRouteMiddleware } from '#app'

export default defineNuxtRouteMiddleware( () => {
  void useListsApi()
})
